import { buildinfo } from "@/check"
import { allModules, getAnybuildConfig, getAnybuildConfigAsync, holder } from "./loadModule"
import { getVue3ComponetsConfig, getDevVue3ComponetsConfig } from "./config/components-vue3-config"
import { cwdDir, getBuildinfoVite, clientDir } from "@/share"
import path from "node:path"
import { pathToFileURL } from "node:url"
import fs from "fs-extra"
import lodash from "lodash-es"

const { ensureFileSync, pathExistsSync, readFileSync, readJSONSync, writeFileSync, unlinkSync } = fs

export async function buildComponentsVue3ByVite() {
    let _config = getBuildinfoVite()
    const { vite: { build } } = allModules

    console.log(`检测到组件库`)
    console.log(`打包es组件库`)
    const viteConfigES = getVue3ComponetsConfig(true)
    await build(viteConfigES)
    console.log(`打包cjs组件库`)
    const viteConfigCJS = getVue3ComponetsConfig(false)
    await build(viteConfigCJS)
}

export async function devSiteByVite() {
    let _config = getBuildinfoVite()
    const { vite: { build, createServer } } = allModules

    const viteConfig = await getDevVue3ComponetsConfig()
    const server = await createServer({
        ...viteConfig,
        logLevel: 'info',
        server: {
            port: 3366,
            host: '0.0.0.0'
        }
    })
    await server.listen()
    server.printUrls()
}

async function renderPage(p: string, htmlPath: string, { render, manifest, clientResult, renderData, matchedStr }) {
    try {
        const [appHtml, metas, _title] = await render(p, manifest)
        if (!matchedStr) {
            const appChunk =
                clientResult &&
                (clientResult.output.find(
                    (chunk) =>
                        chunk.type === 'chunk' &&
                        chunk.isEntry &&
                        chunk.facadeModuleId?.endsWith('desktop/main.ts')
                ))

            const cssChunk = clientResult.output.filter(
                (chunk) => chunk.type === 'asset' && chunk.fileName.endsWith('.css')
            );


            const assets = clientResult.output
                .filter(
                    (chunk) => chunk.type === 'asset' && !chunk.fileName.endsWith('.css')
                )
                .map((asset) => asset.fileName)

            const scriptStr = appChunk
                ? `<script type="module" src="/${appChunk.fileName}"></script>`
                : ``

            const stylesheetLink = cssChunk.map(v => {
                return `<link rel="preload stylesheet" href="/${v.fileName}" as="style">`
            }).join("\n") ?? ''

            /**
             * 考虑不读取，直接字符串拼接快一点, 不同页面也需要不同的标题与meta
             */
            let indexHTML = readFileSync(path.resolve(clientDir, "./index.html"), "utf-8")
            indexHTML = lodash.template(indexHTML)(renderData);
            indexHTML = indexHTML.replace(/<\!--preload-links-->/g, stylesheetLink)
            indexHTML = indexHTML.replace(/<title>[\s\S]*?<\/title>/g, `<title>${_title}</title>`)
            indexHTML = indexHTML.replace(/<\!--ENRTYSTART-->[\s\S]*?<\!--ENRTYEND-->/g, scriptStr)
            indexHTML = indexHTML.replace(/<\!--app-html-->/g, appHtml)

            const metaStr = []
            for (let i = 0; i < metas.length; i++) {
                const mm = metas[i];
                let startMeta = ["<meta "]

                for (const key in mm) {
                    startMeta.push(`${key}="${mm[key]}" `)
                }
                startMeta.push(">")
                if (startMeta.length > 2) {
                    metaStr.push(startMeta.join(''))
                }
            }
            if (metaStr.length) {
                indexHTML = indexHTML.replace(/<\!--meta-data-->/g, metaStr.join('\n'))
            } else {
                indexHTML = indexHTML.replace(/<\!--meta-data-->/g, '')
            }

            ensureFileSync(path.resolve(cwdDir, `./.anybuild/dist/${htmlPath}`))
            writeFileSync(path.resolve(cwdDir, `./.anybuild/dist/${htmlPath}`), indexHTML, "utf-8")
        } else {
            let indexHTML = readFileSync(path.resolve(clientDir, "./index.html"), "utf-8")
            indexHTML = lodash.template(indexHTML)(renderData);
            indexHTML = indexHTML.replace(/<\!--preload-links-->/g, matchedStr)
            indexHTML = indexHTML.replace(/<title>[\s\S]*?<\/title>/g, `<title>${_title}</title>`)
            indexHTML = indexHTML.replace(/<\!--ENRTYSTART-->[\s\S]*?<\!--ENRTYEND-->/g, "")
            indexHTML = indexHTML.replace(/<\!--app-html-->/g, appHtml)

            const metaStr = []
            for (let i = 0; i < metas.length; i++) {
                const mm = metas[i];
                let startMeta = ["<meta "]

                for (const key in mm) {
                    startMeta.push(`${key}="${mm[key]}" `)
                }
                startMeta.push(">")
                if (startMeta.length > 2) {
                    metaStr.push(startMeta.join(''))
                }
            }
            if (metaStr.length) {
                indexHTML = indexHTML.replace(/<\!--meta-data-->/g, metaStr.join('\n'))
            } else {
                indexHTML = indexHTML.replace(/<\!--meta-data-->/g, '')
            }

            ensureFileSync(path.resolve(cwdDir, `./.anybuild/dist/${htmlPath}`))
            writeFileSync(path.resolve(cwdDir, `./.anybuild/dist/${htmlPath}`), indexHTML, "utf-8")
        }
    } catch (error) {
        throw error
    }
}

export async function buildSiteByVite(isSSR) {
    const { vite: { build } } = allModules
    const myConfig = getAnybuildConfig();

    if (isSSR) {
        console.log(" client rendering, server rendering ");
        const [serverResult, clientResult] = await Promise.all([
            build(await getDevVue3ComponetsConfig(true)) as any, // ssr
            build(await getDevVue3ComponetsConfig(true, true)) as any // 客户端
        ])

        // https://github.com/vuejs/vitepress/blob/da1691d77e371892cbe566ba45ca24f1fa03dc7c/src/node/build/render.ts
        // https://github.com/vuejs/vitepress/blob/da1691d77e371892cbe566ba45ca24f1fa03dc7c/src/node/build/build.ts
        const entryPath = path.resolve(cwdDir, './.anybuild/.tempDir/app.js')
        const manifest = JSON.parse(
            readFileSync(path.resolve(cwdDir, './.anybuild/.tempDir/ssr-manifest.json'), 'utf-8'),
        )

        const indexHTML = path.resolve(cwdDir, './.anybuild/dist/index.html')
        const aa = String(readFileSync(indexHTML)).match(/<\!--preload-links-->([\s\S]*?)<\/head>/)
        const [, matchedStr] = aa ?? []
        unlinkSync(indexHTML)


        const { render } = await import(pathToFileURL(entryPath).toString())
        const siteinfoPath = path.resolve(cwdDir, ".anybuild/siteinfo.json")
        let renderData: any = {}
        if (pathExistsSync(siteinfoPath)) {
            renderData = readJSONSync(siteinfoPath)
        }

        let pagesPromise = []
        for (let i = 0; i < renderData.navbar.length; i++) {
            const element = renderData.navbar[i];
            let htmlP = '/zh/' + element.path + '/index.html'
            if (htmlP === "/zh/docs/home/index.html") {
                htmlP = "index.html"
                pagesPromise.push(renderPage('/zh/' + element.path, htmlP, { manifest, clientResult, render, renderData, matchedStr }))
            } else {
                pagesPromise.push(renderPage('/zh/' + element.path, htmlP, { manifest, clientResult, render, renderData, matchedStr }))
                pagesPromise.push(renderPage('/en/' + element.path, htmlP.replace("zh", "en"), { manifest, clientResult, render, renderData, matchedStr }))
            }
        }
        for (let i = 0; i < renderData.action.length; i++) {
            const element = renderData.action[i];
            let htmlP = '/zh/' + element.path + '/index.html'
            if (htmlP === "/zh/docs/home/index.html") {
                htmlP = "index.html"
                pagesPromise.push(renderPage('/zh/' + element.path, htmlP, { manifest, clientResult, render, renderData, matchedStr }))
            } else {
                pagesPromise.push(renderPage('/zh/' + element.path, htmlP, { manifest, clientResult, render, renderData, matchedStr }))
                pagesPromise.push(renderPage('/en/' + element.path, htmlP.replace("zh", "en"), { manifest, clientResult, render, renderData, matchedStr }))
            }
        }
        for (let i = 0; i < renderData.sidebar.length; i++) {
            const element = renderData.sidebar[i];
            if (element.items) {
                for (let j = 0; j < element.items.length; j++) {
                    const item = element.items[j];
                    let htmlP = '/zh/' + item.path + '/index.html'
                    if (htmlP === "/zh/docs/home/index.html") {
                        htmlP = "index.html"
                        pagesPromise.push(renderPage('/zh/' + item.path, htmlP, { manifest, clientResult, render, renderData, matchedStr }))
                    } else {
                        pagesPromise.push(renderPage('/zh/' + item.path, htmlP, { manifest, clientResult, render, renderData, matchedStr }))
                        pagesPromise.push(renderPage('/en/' + item.path, htmlP.replace("zh", "en"), { manifest, clientResult, render, renderData, matchedStr }))
                    }
                }
            }
        }
        await Promise.all(pagesPromise)

        // const [appHtml, preloadLinks] = await render("/zh/docs/home", manifest)
        // writeFileSync("./appHtml.html", appHtml, "utf-8")
        // writeFileSync("./preloadLinks.html", preloadLinks, "utf-8")
    } else {
        const viteConfig = await getDevVue3ComponetsConfig()
        await build(viteConfig)
    }
}